import { Link } from "react-router-dom";
import "../../../styles/Containers.css";

function DietBanner(props) {
  const { linkTo, bclass, category, title, status, statusTagClass, onClick, description, imgSrc } = props;
  return (
    <div>
      <Link to={linkTo} onClick={onClick} className={bclass}>
        <div className="padding5 shadow-normal radius2 b-white marginUpDown5">
        <div className="spc-between">
          <div className="rightAlign grey-1">
            <p className="caption-1 grey-2">{category}</p>
            <p className="heading-1 gradient-1">{title}</p>
            </div>
          <div>
            <p className={statusTagClass}>{status}</p>
            {/* <p className="big-1 heightAuto">{img}</p> */}
          </div>
        </div>
        <div>
        <p className="caption-1 yekan grey-1 marginTop5 rightAlign">{description}</p>
        <img src ={imgSrc} className="width100 max-width500"></img>
        </div>
        </div>
      </Link>
    </div>
  );
}
export default DietBanner;
